import { render, staticRenderFns } from "./supplierMovement.vue?vue&type=template&id=e5157120"
import script from "./supplierMovement.vue?vue&type=script&lang=js"
export * from "./supplierMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports